import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { OrderPochtaCourierAddressWrite } from './OrderPochtaCourierAddressWrite'
/**
* Class UpdateOrderDeliveryPochtaCourier
*  Доставка Почта России курьером: адрес до двери, без ОПС назначения.
*/
export class UpdateOrderDeliveryPochtaCourier extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'PochtaCourier' })
  readonly kind: string = 'PochtaCourier'


  /**
  * deliveryMethodId
  * Идентификатор способа из каталога канала.  */
  @ActiveField(0)
  deliveryMethodId: number = 0


  /**
  * deliverTo
  * Адрес назначения (индекс, город, улица и дом обязательны).  */
  @ActiveField({
    factory: [OrderPochtaCourierAddressWrite, () => undefined]
  })
  deliverTo?: OrderPochtaCourierAddressWrite
}
